module.exports = __webpack_public_path__ + "static/media/showroomIco_Selected.fa65ab6d.svg";